module.exports = __webpack_public_path__ + "img/Shiokko_Profile_2.370d2702.png";